




































































































import { Component, Vue } from 'vue-property-decorator';

@Component({})
export default class MenuComponent extends Vue {
  account = this.$store.state.account;
  application = this.$store.state.application;

  get isMenuVisible() {
    return this.account.status.loggedIn && this.application.menuVisible;
  }

  toggleMenu() {
    this.$store.dispatch('application/toggleMenu');
  }

  logout() {
    this.$store.dispatch('account/logout');
    window.location.replace('/logout');
  }
}
